import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Twitter, Github, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="marketing-footer" className="border-t border-white/5 bg-background/60 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2 font-display text-lg font-semibold">
            <span className="grid place-items-center w-8 h-8 rounded-lg bg-gradient-to-br from-cyan-400 to-pink-500">
              <Sparkles className="w-4 h-4 text-zinc-950" />
            </span>
            TikBoost <span className="text-cyan-400">AI</span>
          </Link>
          <p className="mt-4 text-sm text-muted-foreground max-w-md leading-relaxed">
            The AI growth toolkit for modern creators. Turn ideas into scroll-stopping content,
            engineered for TikTok and short-form video.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href="#" aria-label="Twitter" className="w-9 h-9 grid place-items-center rounded-full border border-border hover:border-cyan-500 transition-colors" data-testid="footer-twitter">
              <Twitter className="w-4 h-4" />
            </a>
            <a href="#" aria-label="GitHub" className="w-9 h-9 grid place-items-center rounded-full border border-border hover:border-cyan-500 transition-colors" data-testid="footer-github">
              <Github className="w-4 h-4" />
            </a>
            <a href="#" aria-label="LinkedIn" className="w-9 h-9 grid place-items-center rounded-full border border-border hover:border-cyan-500 transition-colors" data-testid="footer-linkedin">
              <Linkedin className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-muted-foreground">Product</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/features" className="hover:text-cyan-400 transition-colors">Features</Link></li>
            <li><Link to="/pricing" className="hover:text-cyan-400 transition-colors">Pricing</Link></li>
            <li><Link to="/register" className="hover:text-cyan-400 transition-colors">Sign up</Link></li>
            <li><Link to="/login" className="hover:text-cyan-400 transition-colors">Log in</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-muted-foreground">Company</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/contact" className="hover:text-cyan-400 transition-colors">Contact</Link></li>
            <li><Link to="/admin/login" className="hover:text-cyan-400 transition-colors">Admin</Link></li>
            <li><a href="#" className="hover:text-cyan-400 transition-colors">Privacy</a></li>
            <li><a href="#" className="hover:text-cyan-400 transition-colors">Terms</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs text-muted-foreground flex flex-col md:flex-row items-center justify-between gap-2">
          <p>© {new Date().getFullYear()} TikBoost AI. All rights reserved.</p>
          <p>Crafted for creators who ship daily.</p>
        </div>
      </div>
    </footer>
  );
}
